// @ts-nocheck
import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { authHeader } from "auth/authHeader";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import { getToken } from "auth/authenticate";

// change Appointment dialog
const ChangeAppointmentDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const ChangeAppointmentDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

ChangeAppointmentDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function ChangeAppointmentModal(props) {
  const [date, setDate] = useState(new Date());
  const [availability, setAvailability] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  // const [slotType, setSlotType] = useState(null);

  const handleDateChange = (dateP) => {
    setDate(dateP);
    setSelected(null);
    loadAllAppointments(dateP);
  };

  const loadAllAppointments = (dateP) => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}availability/patient/get/${
          props.appointment.Doctor.doctorId
        }/${moment(dateP).format("YYYY-MM-DD")}`,
        {
          headers: authHeader(),
        }
      )
      .then(function (response) {
        setAvailability(response.data.data);
      })
      .catch((error) => {
        // JSON.stringify(error);
        // console.log(error.response.data.error);
        // setError(error.response.data.error);
        // setError("Invalid Credentials");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadAllAppointments(date);
  }, []);

  const changeAppointment = () => {
    try {
      var bodyFormData = new FormData();

      bodyFormData.append("date", moment(date).format("YYYY-MM-DD"));
      bodyFormData.append("slotTime", selected);
      // bodyFormData.append("slotType", slotType);

      axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}appointment/patient/${props.appointment.appointmentId}`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + getToken(),
        },
      })
        .then(function (response) {
          if (response) {
            props.handleChangeAppointmentClose();
          }
        })
        .catch(function (response) {
          //handle error
          // console.log(response);
        })
        .finally(() => {
          props.handleChangeAppointmentClose();
        });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <ChangeAppointmentDialog
        onClose={props.handleChangeAppointmentClose}
        aria-labelledby="customized-dialog-title"
        open={props.changeAppointmentOpen}
      >
        <DialogContent className="NextAppointmentDialogContent">
          <h3>Select Date {"&"} Time</h3>
          <h4>Choose Date</h4>
          <DatePicker
            value={date}
            onChange={(newValue) => {
              handleDateChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          {/* <h4>Choose 3 Time Slots</h4> */}

          {loading ? (
            <center>
              <CircularProgress />
            </center>
          ) : (
            // <>
            //   <h5>
            //     Morning {availability?.morning.length} slots
            //     <span>(15 min slots)</span>
            //   </h5>
            //   <div className="afternoonSlotBtn">
            //     {availability?.morning?.map((item, ind) => {
            //       return (
            //         <Button
            //           key={ind}
            //           variant="text"
            //           onClick={() => {
            //             setSelected(item);
            //             setSlotType("MORNING");
            //           }}
            //           className={
            //             item == selected ? "activeSlotBtn" : "slotButton"
            //           }
            //         >
            //           {item}
            //         </Button>
            //       );
            //     })}
            //   </div>
            //   <h5>
            //     Evening {availability?.evening.length} slots{" "}
            //     <span>(15 min slots)</span>
            //   </h5>
            //   <div className="afternoonSlotBtn">
            //     {availability?.evening?.map((item, ind) => {
            //       return (
            //         <Button
            //           key={ind}
            //           variant="text"
            //           onClick={() => {
            //             setSelected(item);
            //             setSlotType("EVENING");
            //           }}
            //           className={
            //             item == selected ? "activeSlotBtn" : "slotButton"
            //           }
            //         >
            //           {item}
            //         </Button>
            //       );
            //     })}
            //   </div>
            // </>
            <>
              <h5>
                {availability?.length} slots
                <span>(15 min slots)</span>
              </h5>
              <div className="afternoonSlotBtn">
                {availability?.map((item, ind) => {
                  return (
                    <Button
                      key={ind}
                      variant="text"
                      onClick={() => {
                        setSelected(item);
                      }}
                      className={
                        item == selected ? "activeSlotBtn" : "slotButton"
                      }
                    >
                      {item}
                    </Button>
                  );
                })}
              </div>
              {/* <h5>
                Evening {availability?.evening.length} slots{" "}
                <span>(15 min slots)</span>
              </h5>
              <div className="afternoonSlotBtn">
                {availability?.evening?.map((item, ind) => {
                  return (
                    <Button
                      key={ind}
                      variant="text"
                      onClick={() => {
                        setSelected(item);
                        setSlotType("EVENING");
                      }}
                      className={
                        item == selected ? "activeSlotBtn" : "slotButton"
                      }
                    >
                      {item}
                    </Button>
                  );
                })}
              </div> */}
            </>
          )}
        </DialogContent>
        <DialogActions className="nextAppointmentAction">
          <Button
            autoFocus
            onClick={changeAppointment}
            className="nextAppointmentDoneBtn"
          >
            Done
          </Button>
        </DialogActions>
      </ChangeAppointmentDialog>
    </div>
  );
}

export { ChangeAppointmentModal };
